var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("room",[_c('display-field',{attrs:{"label":_vm.label}},[_c('span',[_vm._v(" "+_vm._s(_vm.roomCode)+" "),(_vm.room && _vm.room.roomName)?_c('span',[_vm._v(" - "+_vm._s(_vm.room.roomName))]):_vm._e()])])],{"item":_vm.room})],2)}
var staticRenderFns = []

export { render, staticRenderFns }